// extracted by mini-css-extract-plugin
export default {"YoutubeEmbed":"bav_a"};